import {RYHMÄ, TYYPPI} from './constants'

const testit = { // muuta testi --> testiaineisto	
	"H3/300": {
	  nimi:       "Kolmen hajotelma",	 
		lyhytnimi:  "Harjoittele!",	
    kuvaus:     "Harjoittele kolmen hajotelmaa 5 minuuttia.",	  
	  tyyppi:     TYYPPI.HARJOITUS,
    ryhmä:      RYHMÄ.HAJOTELMAT,
	  materiaali: 3,
	  tehtäviä:   0,
	  aika:       300  		
	},
	"H3/180": {
	  nimi:       "Kolmen hajotelma",
		lyhytnimi:  "Testaa!",	
	  kuvaus:     "50 tehtävää kolmen hajotelmasta, joiden suorittamiseen saa käyttää aikaa maksimissaan 3 minuuttia",
	  tyyppi:     TYYPPI.TESTI,
	  ryhmä:      RYHMÄ.HAJOTELMAT,
	  materiaali: 3,
	  tehtäviä:   50,
	  aika:       180
	},	
	"H4/300": {
	  nimi:       "Neljän hajotelma",	 
		lyhytnimi:  "Harjoittele!",	
    kuvaus:     "Harjoittele neljän hajotelmaa 5 minuuttia.",	  
	  tyyppi:     TYYPPI.HARJOITUS,
    ryhmä:      RYHMÄ.HAJOTELMAT,
	  materiaali: 4,
	  tehtäviä:   0,
	  aika:       300  		
	},
	"H4/180": {
	  nimi:       "Neljän hajotelma",
    lyhytnimi:  "Testaa!",			
	  kuvaus:     "50 tehtävää neljän hajotelmasta, joiden suorittamiseen saa käyttää aikaa maksimissaan 3 minuuttia",
	  tyyppi:     TYYPPI.TESTI,
	  ryhmä:      RYHMÄ.HAJOTELMAT,
	  materiaali: 4,
	  tehtäviä:   50,
	  aika:       180
	},		
	"H5/300": {
	  nimi:       "Viiden hajotelma",	 
		lyhytnimi:  "Harjoittele!",	
    kuvaus:     "Harjoittele viiden hajotelmaa 5 minuuttia.",	  
	  tyyppi:     TYYPPI.HARJOITUS,
    ryhmä:      RYHMÄ.HAJOTELMAT,
	  materiaali: 5,
	  tehtäviä:   0,
	  aika:       300  		
	},
	"H5/180": {
	  nimi:       "Viiden hajotelma",
		lyhytnimi:  "Testaa!",	
	  kuvaus:     "50 tehtävää viiden hajotelmasta, joiden suorittamiseen saa käyttää aikaa maksimissaan 3 minuuttia.",
	  tyyppi:     TYYPPI.TESTI,
	  ryhmä:      RYHMÄ.HAJOTELMAT,
	  materiaali: 5,
	  tehtäviä:   50,
	  aika:       180
	},
  "H6/300": {
	  nimi:       "Kuuden hajotelma",	
		lyhytnimi:  "Harjoittele!",	 
    kuvaus:     "Harjoittele kuuden hajotelmaa 5 minuuttia.",	  
	  tyyppi:     TYYPPI.HARJOITUS,
    ryhmä:      RYHMÄ.HAJOTELMAT,
	  materiaali: 6,
	  tehtäviä:   0,
	  aika:       300  		
	},
	"H6/210": {
	  nimi:       "Kuuden hajotelma",
		lyhytnimi:  "Testaa!",	
	  kuvaus:     "50 tehtävää kuuden hajotelmasta, joiden suorittamiseen saa käyttää aikaa maksimissaan 3 minuuttia ja 30 sekuntia.",
	  tyyppi:     TYYPPI.TESTI,
	  ryhmä:      RYHMÄ.HAJOTELMAT,
	  materiaali: 6,
	  tehtäviä:   50,
	  aika:       210
	},	
	"H7/300": {
	  nimi:       "Seitsemän hajotelma",	 
		lyhytnimi:  "Harjoittele!",	
    kuvaus:     "Harjoittele seitsemän hajotelmaa 5 minuuttia.",	  
	  tyyppi:     TYYPPI.HARJOITUS,
    ryhmä:      RYHMÄ.HAJOTELMAT,
	  materiaali: 7,
	  tehtäviä:   0,
	  aika:       300  		
	},
	"H7/210": {
	  nimi:       "Seitsemän hajotelma",
		lyhytnimi:  "Testaa!",	
	  kuvaus:     "50 tehtävää seitsemän hajotelmasta, joiden suorittamiseen saa käyttää aikaa maksimissaan 3 minuuttia ja 30 sekuntia.",
	  tyyppi:     TYYPPI.TESTI,
	  ryhmä:      RYHMÄ.HAJOTELMAT,
	  materiaali: 7,
	  tehtäviä:   50,
	  aika:       210
	},	
	"H8/300": {
	  nimi:       "Kahdeksan hajotelma",	 
		lyhytnimi:  "Harjoittele!",	
    kuvaus:     "Harjoittele kahdeksan hajotelmaa 5 minuuttia.",	  
	  tyyppi:     TYYPPI.HARJOITUS,
    ryhmä:      RYHMÄ.HAJOTELMAT,
	  materiaali: 8,
	  tehtäviä:   0,
	  aika:       300  		
	},
	"H8/210": {
	  nimi:       "Kahdeksan hajotelma",
		lyhytnimi:  "Testaa!",	
	  kuvaus:     "50 tehtävää kahdeksan hajotelmasta, joiden suorittamiseen saa käyttää aikaa maksimissaan 3 minuuttia ja 30 sekuntia.",
	  tyyppi:     TYYPPI.TESTI,
	  ryhmä:      RYHMÄ.HAJOTELMAT,
	  materiaali: 8,
	  tehtäviä:   50,
	  aika:       210
	},	
	"H9/300": {
	  nimi:       "Yhdeksän hajotelma",	 
		lyhytnimi:  "Harjoittele!",	
    kuvaus:     "Harjoittele yhdeksän hajotelmaa 5 minuuttia.",	  
	  tyyppi:     TYYPPI.HARJOITUS,
    ryhmä:      RYHMÄ.HAJOTELMAT,
	  materiaali: 9,
	  tehtäviä:   0,
	  aika:       300  		
	},
	"H9/210": {
	  nimi:       "Yhdeksän hajotelma",
		lyhytnimi:  "Testaa!",	
	  kuvaus:     "50 tehtävää yhdeksän hajotelmasta, joiden suorittamiseen saa käyttää aikaa maksimissaan 3 minuuttia ja 30 sekuntia.",
	  tyyppi:     TYYPPI.TESTI,
	  ryhmä:      RYHMÄ.HAJOTELMAT,
	  materiaali: 9,
	  tehtäviä:   50,
	  aika:       210
	},	
	"H10/300": {
	  nimi:       "Kympin hajotelma",	 
		lyhytnimi:  "Harjoittele!",	
    kuvaus:     "Harjoittele kympin hajotelmaa 5 minuuttia.",	  
	  tyyppi:     TYYPPI.HARJOITUS,
    ryhmä:      RYHMÄ.HAJOTELMAT,
	  materiaali: "10",
	  tehtäviä:   0,
	  aika:       300  		
	},
	"H10/210": {
	  nimi:       "Kympin hajotelma",
		lyhytnimi:  "Testaa!",	
	  kuvaus:     "50 tehtävää kympin hajotelmasta, joiden suorittamiseen saa käyttää aikaa maksimissaan 3 minuuttia ja 30 sekuntia.",
	  tyyppi:     TYYPPI.TESTI,
	  ryhmä:      RYHMÄ.HAJOTELMAT,
	  materiaali: "10",
	  tehtäviä:   50,
	  aika:       210
	},	
	"H3-10+/300": {
	  nimi:       "Hajotelmia yhteenlaskuina",	 
		lyhytnimi:  "Harjoittele!",	
    kuvaus:     "Harjoittele hajotelmia yhteenlaskuina 5 minuuttia.",	  
	  tyyppi:     TYYPPI.HARJOITUS,
    ryhmä:      RYHMÄ.HAJOTELMAT,
	  materiaali: "3-10+",
	  tehtäviä:   0,
	  aika:       300  		
	},
	"H3-10+/180": {
	  nimi:       "Hajotelmia yhteenlaskuina",
		lyhytnimi:  "Testaa!",	
	  kuvaus:     "50 tehtävää hajotelmista yhteenlaskuina, joiden suorittamiseen saa käyttää aikaa maksimissaan 3 minuuttia.",
	  tyyppi:     TYYPPI.TESTI,
	  ryhmä:      RYHMÄ.HAJOTELMAT,
	  materiaali: "3-10+",
	  tehtäviä:   50,
	  aika:       180
	},		
	"H3-10-/300": {
	  nimi:       "Hajotelmia vähennyslaskuina",	 
		lyhytnimi:  "Harjoittele!",	
    kuvaus:     "Harjoittele hajotelmia vähennyslaskuina 5 minuuttia.",	  
	  tyyppi:     TYYPPI.HARJOITUS,
    ryhmä:      RYHMÄ.HAJOTELMAT,
	  materiaali: "3-10-",
	  tehtäviä:   0,
	  aika:       300  		
	},
	"H3-10-/180": {
	  nimi:       "Hajotelmia vähennyslaskuina",
		lyhytnimi:  "Testaa!",	
	  kuvaus:     "50 tehtävää hajotelmista vähennyslaskuina, joiden suorittamiseen saa käyttää aikaa maksimissaan 3 minuuttia.",
	  tyyppi:     TYYPPI.TESTI,
	  ryhmä:      RYHMÄ.HAJOTELMAT,
	  materiaali: "3-10-",
	  tehtäviä:   50,
	  aika:       180
	},	
	"K2/0": {
	  nimi:       "Kahden kertotaulu",
		lyhytnimi:  "Harjoittele!",	
	  kuvaus:     "100 tehtävää kahden kertotaulusta, joiden suoritusaikaa ei ole rajoitettu.",
	  tyyppi:     TYYPPI.HARJOITUS,
	  ryhmä:      RYHMÄ.KERTOTAULUT,
	  materiaali: 2,
	  tehtäviä:   100,
	  aika:       0
	},	
	"K2/210": {
	  nimi:       "Kahden kertotaulu",
		lyhytnimi:  "Testaa!",	
	  kuvaus:     "50 tehtävää kahden kertotaulusta, joiden suorittamiseen saa käyttää aikaa maksimissaan 3 minuuttia ja 30 sekuntia.",
	  tyyppi:     TYYPPI.TESTI,
	  ryhmä:      RYHMÄ.KERTOTAULUT,
	  materiaali: 2,
	  tehtäviä:   50,
	  aika:       210
	},		
	"K3/0": {
	  nimi:       "Kolmen kertotaulu",
		lyhytnimi:  "Harjoittele!",	
	  kuvaus:     "100 tehtävää kolmen kertotaulusta, joiden suoritusaikaa ei ole rajoitettu.",
	  tyyppi:     TYYPPI.HARJOITUS,
	  ryhmä:      RYHMÄ.KERTOTAULUT,
	  materiaali: 3,
	  tehtäviä:   100,
	  aika:       0
	},	
	"K3/210": {
	  nimi:       "Kolmen kertotaulu",
		lyhytnimi:  "Testaa!",	
	  kuvaus:     "50 tehtävää kolmen kertotaulusta, joiden suorittamiseen saa käyttää aikaa maksimissaan 3 minuuttia ja 30 sekuntia.",
	  tyyppi:     TYYPPI.TESTI,
	  ryhmä:      RYHMÄ.KERTOTAULUT,
	  materiaali: 3,
	  tehtäviä:   50,
	  aika:       210
	},		
	"K4/0": {
	  nimi:       "Neljän kertotaulu",
		lyhytnimi:  "Harjoittele!",	
	  kuvaus:     "100 tehtävää neljän kertotaulusta, joiden suoritusaikaa ei ole rajoitettu.",
	  tyyppi:     TYYPPI.HARJOITUS,
	  ryhmä:      RYHMÄ.KERTOTAULUT,
	  materiaali: 4,
	  tehtäviä:   100,
	  aika:       0
	},	
	"K4/210": {
	  nimi:       "Neljän kertotaulu",
		lyhytnimi:  "Testaa!",	
	  kuvaus:     "50 tehtävää neljän kertotaulusta, joiden suorittamiseen saa käyttää aikaa maksimissaan 3 minuuttia ja 30 sekuntia.",
	  tyyppi:     TYYPPI.TESTI,
	  ryhmä:      RYHMÄ.KERTOTAULUT,
	  materiaali: 4,
	  tehtäviä:   50,
	  aika:       210
	},	
	"K5/0": {
	  nimi:       "Viiden kertotaulu",
		lyhytnimi:  "Harjoittele!",	
	  kuvaus:     "100 tehtävää viiden kertotaulusta, joiden suoritusaikaa ei ole rajoitettu.",
	  tyyppi:     TYYPPI.HARJOITUS,
	  ryhmä:      RYHMÄ.KERTOTAULUT,
	  materiaali: 5,
	  tehtäviä:   100,
	  aika:       0
	},	
	"K5/210": {
	  nimi:       "Viiden kertotaulu",
		lyhytnimi:  "Testaa!",	
	  kuvaus:     "50 tehtävää viiden kertotaulusta, joiden suorittamiseen saa käyttää aikaa maksimissaan 3 minuuttia ja 30 sekuntia.",
	  tyyppi:     TYYPPI.TESTI,
	  ryhmä:      RYHMÄ.KERTOTAULUT,
	  materiaali: 5,
	  tehtäviä:   50,
	  aika:       210
	},			
	"K6/0": {
	  nimi:       "Kuuden kertotaulu",
		lyhytnimi:  "Harjoittele!",	
	  kuvaus:     "100 tehtävää kuuden kertotaulusta, joiden suoritusaikaa ei ole rajoitettu.",
	  tyyppi:     TYYPPI.HARJOITUS,
	  ryhmä:      RYHMÄ.KERTOTAULUT,
	  materiaali: 6,
	  tehtäviä:   100,
	  aika:       0
	},	
	"K6/180": {
	  nimi:       "Kuuden kertotaulu",
		lyhytnimi:  "Testaa!",	
	  kuvaus:     "50 tehtävää kuuden kertotaulusta, joiden suorittamiseen saa käyttää aikaa maksimissaan 3 minuuttia.",
	  tyyppi:     TYYPPI.TESTI,
	  ryhmä:      RYHMÄ.KERTOTAULUT,
	  materiaali: 6,
	  tehtäviä:   50,
	  aika:       180
	},		
	"K7/0": {
	  nimi:       "Seitsemän kertotaulu",
		lyhytnimi:  "Harjoittele!",	
	  kuvaus:     "100 tehtävää seitsemän kertotaulusta, joiden suoritusaikaa ei ole rajoitettu.",
	  tyyppi:     TYYPPI.HARJOITUS,
	  ryhmä:      RYHMÄ.KERTOTAULUT,
	  materiaali: 7,
	  tehtäviä:   100,
	  aika:       0
	},	
	"K7/180": {
	  nimi:       "Seitsemän kertotaulu",
		lyhytnimi:  "Testaa!",	
	  kuvaus:     "50 tehtävää seitsemän kertotaulusta, joiden suorittamiseen saa käyttää aikaa maksimissaan 3 minuuttia.",
	  tyyppi:     TYYPPI.TESTI,
	  ryhmä:      RYHMÄ.KERTOTAULUT,
	  materiaali: 7,
	  tehtäviä:   50,
	  aika:       180
	},		
	"K8/0": {
	  nimi:       "Kahdeksan kertotaulu",
		lyhytnimi:  "Harjoittele!",	
	  kuvaus:     "100 tehtävää kahdeksan kertotaulusta, joiden suoritusaikaa ei ole rajoitettu.",
	  tyyppi:     TYYPPI.HARJOITUS,
	  ryhmä:      RYHMÄ.KERTOTAULUT,
	  materiaali: 8,
	  tehtäviä:   100,
	  aika:       0
	},	
	"K8/180": {
	  nimi:       "Kahdeksan kertotaulu",
		lyhytnimi:  "Testaa!",	
	  kuvaus:     "50 tehtävää kahdeksan kertotaulusta, joiden suorittamiseen saa käyttää aikaa maksimissaan 3 minuuttia.",
	  tyyppi:     TYYPPI.TESTI,
	  ryhmä:      RYHMÄ.KERTOTAULUT,
	  materiaali: 8,
	  tehtäviä:   50,
	  aika:       180
	},	
	"K9/0": {
	  nimi:       "Yhdeksän kertotaulu",
		lyhytnimi:  "Harjoittele!",	
	  kuvaus:     "100 tehtävää yhdeksän kertotaulusta, joiden suoritusaikaa ei ole rajoitettu.",
	  tyyppi:     TYYPPI.HARJOITUS,
	  ryhmä:      RYHMÄ.KERTOTAULUT,
	  materiaali: 9,
	  tehtäviä:   100,
	  aika:       0
	},	
	"K9/180": {
	  nimi:       "Yhdeksän kertotaulu",
		lyhytnimi:  "Testaa!",	
	  kuvaus:     "50 tehtävää yhdeksän kertotaulusta, joiden suorittamiseen saa käyttää aikaa maksimissaan 3 minuuttia.",
	  tyyppi:     TYYPPI.TESTI,
	  ryhmä:      RYHMÄ.KERTOTAULUT,
	  materiaali: 9,
	  tehtäviä:   50,
	  aika:       180
	},	
	"K10/0": {
	  nimi:       "Kymmenen kertotaulu",
		lyhytnimi:  "Harjoittele!",	
	  kuvaus:     "100 tehtävää kymmenen kertotaulusta, joiden suoritusaikaa ei ole rajoitettu.",
	  tyyppi:     TYYPPI.HARJOITUS,
	  ryhmä:      RYHMÄ.KERTOTAULUT,
	  materiaali: 10,
	  tehtäviä:   100,
	  aika:       0
	},	
	"K10/180": {
	  nimi:       "Kymmenen kertotaulu",
		lyhytnimi:  "Testaa!",	
	  kuvaus:     "50 tehtävää kymmenen kertotaulusta, joiden suorittamiseen saa käyttää aikaa maksimissaan 3 minuuttia.",
	  tyyppi:     TYYPPI.TESTI,
	  ryhmä:      RYHMÄ.KERTOTAULUT,
	  materiaali: 10,
	  tehtäviä:   50,
	  aika:       180
	},	
	"K50/600": {
	  nimi:       "Pikkukertotaulut sekaisin",
		lyhytnimi:  "Harjoittele!",	
	  kuvaus:     "Harjoittele pikkukertotauluja 10 minuuttia.",
	  tyyppi:     TYYPPI.HARJOITUS,
	  ryhmä:      RYHMÄ.KERTOTAULUT,
	  materiaali: 50,
	  tehtäviä:   0,
	  aika:       600
	},	
	"K50/210": {
	  nimi:       "Pikkukertotaulut sekaisin",
		lyhytnimi:  "Testaa!",	
	  kuvaus:     "50 tehtävää pikkukertotauluista, joiden suorittamiseen saa käyttää aikaa maksimissaan 3 minuuttia 30 sekuntia.",
	  tyyppi:     TYYPPI.TESTI,
	  ryhmä:      RYHMÄ.KERTOTAULUT,
	  materiaali: 50,
	  tehtäviä:   50,
	  aika:       210
	},		
	"K100/0": {
	  nimi:       "Kertotaulut sekaisin",
		lyhytnimi:  "Harjoittele!",	
	  kuvaus:     "100 tehtävää 2-10 kertotauluista, joiden suoritusaikaa ei ole rajoitettu.",
	  tyyppi:     TYYPPI.HARJOITUS,
	  ryhmä:      RYHMÄ.KERTOTAULUT,
	  materiaali: 100,
	  tehtäviä:   100,
	  aika:       0
	},	
	"K100/360": {
	  nimi:       "Kertotaulut sekaisin",
		lyhytnimi:  "Testaa!",	
	  kuvaus:     "100 tehtävää 2-10 kertotauluista, joiden suorittamiseen saa käyttää aikaa maksimissaan 6 minuuttia.",
	  tyyppi:     TYYPPI.TESTI,
	  ryhmä:      RYHMÄ.KERTOTAULUT,
	  materiaali: 100,
	  tehtäviä:   100,
	  aika:       360
	},	
}

export default testit


// WEBPACK FOOTER //
// ./src/testit.js